/* TUNE MFD setup flow - graph source for the storefront.
 * Edit via tools/flow-lab (export theme data.js) or keep in sync with setup-flow.json.
 */
window.TUNE_SETUP_FLOW = {
  "id": "mfd-setup",
  "version": 10,
  "title": "TUNE MFD Setup",
  "initial": "connection",
  "nodes": {
    "connection": {
      "type": "question",
      "title": "How are you connecting?",
      "body": "Pick the option that matches your setup, or open the wiring diagram.",
      "choices": [
        {
          "id": "can",
          "label": "CAN",
          "next": "can_prereq",
          "set": {
            "bus": "can"
          }
        },
        {
          "id": "obd",
          "label": "OBD2",
          "next": "obd_prereq",
          "set": {
            "bus": "obd"
          }
        },
        {
          "id": "consult",
          "label": "Nissan Consult",
          "next": "consult_prereq",
          "set": {
            "bus": "consult"
          }
        },
        {
          "id": "wiring",
          "label": "Wiring Diagram - ISO Plug",
          "next": "wiring_diagram",
          "separatorBefore": true,
          "separatorTitle": "Wiring reference",
          "variant": "aside"
        }
      ]
    },
    "wiring_diagram": {
      "type": "info",
      "title": "Wiring Diagram",
      "body": "Use this diagram when connecting the TUNE MFD harness: power, ground, CAN High / CAN Low, and accessory leads.",
      "image": "",
      "choices": [
        {
          "id": "back_to_connection",
          "label": "Back to connection options",
          "next": "connection",
          "clearHistory": true
        }
      ]
    },
    "can_prereq": {
      "type": "info",
      "title": "CAN - before you start",
      "body": "Before you start, make sure you have:\n\n• Connected the CAN High and CAN Low wires from the TUNE MFD to your ECU",
      "choices": [
        {
          "id": "ready",
          "label": "I've connected CAN High & Low",
          "next": "can_settings"
        }
      ]
    },
    "can_settings": {
      "type": "info",
      "title": "Open Settings",
      "body": "Tap on the top centre of the screen to reveal the menu bar, then tap on **Settings**.",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "can_add_connection"
        }
      ],
      "video": "https://cdn.shopify.com/videos/c/o/v/08a7958836364b8b81a42c8e64086b9e.mov"
    },
    "can_add_connection": {
      "type": "info",
      "title": "Add connection",
      "body": "Tap on **Add connection**.",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "can_aftermarket"
        }
      ],
      "video": "https://cdn.shopify.com/videos/c/o/v/1bea113c186243549057fdd7c141d578.mov"
    },
    "can_aftermarket": {
      "type": "info",
      "title": "After-Market, CAN",
      "body": "Tap on **After-Market**, then **CAN**.",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "can_ecu"
        }
      ],
      "video": "https://cdn.shopify.com/videos/c/o/v/acc8656a7fa1404ca94a6112df3e7cb2.mov"
    },
    "can_ecu": {
      "type": "info",
      "title": "Select your ECU",
      "body": "Find and select your **ECU**.",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "can_speed"
        }
      ],
      "video": "https://cdn.shopify.com/videos/c/o/v/59706db268204f95b6b31018cd467a87.mov"
    },
    "can_speed": {
      "type": "info",
      "title": "Select CAN Speed",
      "body": "Select your **CAN Speed**.\n\nIf you're unsure of your CAN speed, please refer to your ECU's user guide or contact your tuner.",
      "choices": [
        {
          "id": "next",
          "label": "I've selected CAN Speed",
          "next": "can_home"
        }
      ],
      "video": "https://cdn.shopify.com/videos/c/o/v/757cbbc1ed3a4d639a7167f71358dbac.mov"
    },
    "can_home": {
      "type": "info",
      "title": "Return to the home screen",
      "body": "Return to the home screen. Your live values should now be visible.\nIf your values are not visible, please ensure that you have not swapped the CAN wires and have selected the correct CAN speed.",
      "choices": [
        {
          "id": "done",
          "label": "Live values are showing",
          "next": "can_done"
        }
      ],
      "video": "https://cdn.shopify.com/videos/c/o/v/16c2461d17d549caa9b7254e8d294851.mov"
    },
    "can_done": {
      "type": "terminal",
      "title": "CAN connected",
      "body": "You're set. If live values are missing, re-check CAN High / CAN Low wiring, confirm your ECU selection, and verify the CAN speed matches your ECU.",
      "choices": []
    },
    "obd_prereq": {
      "type": "info",
      "title": "OBD2 - before you start",
      "body": "Before you start, make sure you have:\n\n• Obtained a vLinker FS **USB** OBD2 adapter\n• USB-C to USB-A adapter\n• Connected your vLinker FS to your car's OBD2 port and to the TUNE MFD via the USB-C connector, and confirmed that the light on the adapter is flashing",
      "choices": [
        {
          "id": "ready",
          "label": "Adapter is connected & light is flashing",
          "next": "obd_settings"
        }
      ]
    },
    "obd_settings": {
      "type": "info",
      "title": "Open Settings",
      "body": "Tap on the top centre of the screen to reveal the menu bar, then tap on **Settings**.",
      "video": "https://cdn.shopify.com/videos/c/o/v/db567b9e24ec4e47b8bb93b7775e2b93.mp4",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "obd_add_connection"
        }
      ]
    },
    "obd_add_connection": {
      "type": "info",
      "title": "Add connection - Stock, OBD2",
      "body": "Tap on **Add connection**, then **Stock**, then **OBD2**.",
      "video": "https://cdn.shopify.com/videos/c/o/v/ed2e4e6f7cc34b4994f08a00d96841c4.mp4",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "obd_model"
        }
      ]
    },
    "obd_model": {
      "type": "info",
      "title": "Select your model",
      "body": "Find and select your model. If you don't find it, select **Generic SAE-Compatible Vehicle**.",
      "video": "https://cdn.shopify.com/videos/c/o/v/15ce6e4ffd3f41deb8763bbafd4d765a.mp4",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "obd_serial"
        }
      ]
    },
    "obd_serial": {
      "type": "info",
      "title": "Select Serial & vLinker FS",
      "body": "Select **Serial/USB**, then select **vLinker FS**.",
      "video": "https://cdn.shopify.com/videos/c/o/v/eca1430f21324d5683e79d1b1b5bcb30.mp4",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "obd_baud"
        }
      ]
    },
    "obd_baud": {
      "type": "info",
      "title": "Baud Rate",
      "body": "Ensure the Baud Rate is set to **115200**.",
      "video": "https://cdn.shopify.com/videos/c/o/v/94a9be3b1ca745e4b3c8114894f17ac6.mp4",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "obd_detect"
        }
      ]
    },
    "obd_detect": {
      "type": "info",
      "title": "Detect OBD2 protocol",
      "body": "Open the **OBD2 Monitor**, then select **Detect Protocol** for TUNE to automatically detect your vehicle's OBD2 protocol. Once detected, apply it to your connection setting and select **Done**.",
      "video": "https://cdn.shopify.com/videos/c/o/v/f6f5a65605f04fed8df21acd54a6bf37.mp4",
      "choices": [
        {
          "id": "next",
          "label": "Protocol set",
          "next": "obd_multipid"
        }
      ]
    },
    "obd_multipid": {
      "type": "info",
      "title": "Multiple PID and home screen",
      "body": "Enable **Multiple PID requests** if your ECU supports it, then return to the home screen. Your live values should now be visible.",
      "video": "https://cdn.shopify.com/videos/c/o/v/afb2fe080b8d427caa11f8d115b0631d.mp4",
      "choices": [
        {
          "id": "done",
          "label": "Live values are showing",
          "next": "obd_done"
        }
      ]
    },
    "obd_done": {
      "type": "terminal",
      "title": "OBD2 connected",
      "body": "You're set. If live values are missing, confirm the vLinker FS light is flashing, Baud Rate is **115200**, and protocol detection completed successfully.",
      "choices": []
    },
    "consult_prereq": {
      "type": "info",
      "title": "Nissan Consult - before you start",
      "body": "Before you start, make sure you have:\n\n• Obtained a Nissan Consult USB adapter\n• USB-C to USB-A adapter\n• Connected your Consult adapter to your car's Consult port and to the TUNE MFD via the USB-C connector, and confirmed that the light on the adapter is flashing",
      "choices": [
        {
          "id": "ready",
          "label": "Adapter is connected & light is flashing",
          "next": "consult_settings"
        }
      ]
    },
    "consult_settings": {
      "type": "info",
      "title": "Open Settings",
      "body": "Tap on the top centre of the screen to reveal the menu bar, then tap on **Settings**.",
      "video": "https://cdn.shopify.com/videos/c/o/v/284c36da57e64a74aba289c1cb5ea025.mp4",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "consult_add_connection"
        }
      ]
    },
    "consult_add_connection": {
      "type": "info",
      "title": "Add connection - After-Market, Other",
      "body": "Tap on **Add connection**, then **After-Market**, then **Other**.",
      "video": "https://cdn.shopify.com/videos/c/o/v/dd056ac5cec54cd3a5ccbe63518d3538.mp4",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "consult_select"
        }
      ]
    },
    "consult_select": {
      "type": "info",
      "title": "Nissan Consult I",
      "body": "Scroll down and navigate to **Nissan Consult I**. Tap on it and select **Serial/USB**.",
      "video": "https://cdn.shopify.com/videos/c/o/v/3c2dc94cdc8045288e823b7c51c77138.mp4",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "consult_serial"
        }
      ]
    },
    "consult_serial": {
      "type": "info",
      "title": "Select FT232R & Baud Rate",
      "body": "Select **FT232R**. Ensure the Baud Rate is set to **9600**.",
      "choices": [
        {
          "id": "next",
          "label": "Next",
          "next": "consult_home"
        }
      ],
      "video": "https://cdn.shopify.com/videos/c/o/v/e928261867634fd1a1e71813140a7401.mp4"
    },
    "consult_home": {
      "type": "info",
      "title": "Return to the home screen",
      "body": "Return to the home screen. Your live values should now be visible.",
      "video": "https://cdn.shopify.com/videos/c/o/v/ecc74bd2c100410e9072fffc509bc683.mp4",
      "choices": [
        {
          "id": "done",
          "label": "Live values are showing",
          "next": "consult_done"
        }
      ]
    },
    "consult_done": {
      "type": "terminal",
      "title": "Nissan Consult connected",
      "body": "You're set. If live values are missing, confirm the Consult adapter light is flashing, **FT232R** is selected, and Baud Rate is **9600**.",
      "choices": []
    }
  }
};
